module.exports = __webpack_public_path__ + "static/media/like_selected.00d77f0e.svg";